export var config = {
  background: '#232a2f',
  foreground: '#939da5',
  selection: '#204062',
  selectionMatch: '#204062',
  cursor: '#939da5',
  dropdownBackground: '#1a2023',
  activeLine: '#4469832b',
  matchingBracket: '#204062',
  keyword: '#ba8ef7',
  storage: '#ba8ef7',
  variable: '#939da5',
  parameter: '#939da5',
  function: '#ffea6b',
  string: '#5bec95',
  constant: '#939da5',
  type: '#89ddff',
  class: '#ffea6b',
  number: '#89ddff',
  comment: '#707a84',
  heading: '#5bec95',
  invalid: '#ff6a80',
  regexp: '#56adb7',
  tag: '#ff6a80'
};